import React, { useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/bthTriangle.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";

const statusOptions = [
  { value: "Active", label: "Active" },
  { value: "In-Active", label: "In-Active" },
  { value: "Block", label: "Block" },
];

const userProfileOptions = [
  { value: "CUSTOMER", label: "Customer" },
  { value: "OPERATION", label: "Operation" },
];

const RoleFilterModal = ({
  show,
  handleClose,
  setRoleData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      ...filterData,
      userProfile: filterData.userProfile || null,
      roleName: filterData.roleName || "",
      status: filterData.status || [],
      fromDate: filterData.fromDate || "",
      toDate: filterData.toDate || "",
    },
    mode: "onChange",
  });

  const [selectedTab, setSelectedTab] = useState("User Profile");
  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = (data) => {
    setFilterData(data);
    fetchRoleData(currentPage, data);
  };

  const fetchRoleData = async (page, formData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        userProfile: formData.userProfile?.value || "",
        roleName: formData.roleName || "",
        status:
          formData.status.length > 0
            ? formData.status
            : ["Active", "Block", "In-Active"],
        fromDate: formatDate(formData.fromDate),
        toDate: formatDate(formData.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_ROLE_DATA}?pageSize=${pageSize}&pageNo=${page}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setRoleData(modifiedData);
        setNoData(modifiedData?.length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        setRoleData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      id: index + 1,
    }));
  };

  const onReset = () => {
    reset({
      userProfile: null,
      roleName: "",
      status: [],
      fromDate: "",
      toDate: "",
    });
    setFilterData({
      userProfile: null,
      roleName: "",
      status: [],
      fromDate: "",
      toDate: "",
    });
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <h5 className="modal-title main-title">Filter</h5>
                <HighlightOffIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {[
                        "User Profile",
                        "Role Name",
                        "Status",
                        "Created Date",
                      ].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "User Profile" && (
                        <Controller
                          name="userProfile"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">User Profile</label>
                              <div className="dateInputWrapper">
                                <select
                                  {...field}
                                  value={field.value?.value || ""}
                                  onChange={(e) => {
                                    const selected = userProfileOptions.find(
                                      (opt) => opt.value === e.target.value
                                    );
                                    field.onChange(selected || null);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      userProfile: selected || null,
                                    }));
                                  }}
                                  className="dateInput"
                                >
                                  <option value="">Select User Profile</option>
                                  {userProfileOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Role Name" && (
                        <Controller
                          name="roleName"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Role Name</label>
                              <input
                                {...field}
                                type="text"
                                placeholder="Enter Role Name"
                                className="dateInput"
                                maxLength={50}
                                onChange={(e) => {
                                  field.onChange(e);
                                  setFilterData((prev) => ({
                                    ...prev,
                                    roleName: e.target.value,
                                  }));
                                }}
                              />
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Status" && (
                        <div className="dateField">
                          <label
                            className="dateLabel"
                            style={{
                              marginBottom: "0.5rem",
                              fontWeight: "600",
                              fontSize: "25px",
                            }}
                          >
                            Status
                          </label>
                          <div
                            className="dateInputWrapper"
                            style={{
                              display: "flex",
                              gap: "1rem",
                              flexWrap: "wrap",
                              padding: "0.75rem",
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #ced4da",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {statusOptions.map((status) => (
                              <label
                                key={status.value}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={(filterData.status || []).includes(
                                    status.value
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const newStatus = isChecked
                                      ? [
                                          ...(filterData.status || []),
                                          status.value,
                                        ]
                                      : (filterData.status || []).filter(
                                          (v) => v !== status.value
                                        );
                                    setValue("status", newStatus);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: newStatus,
                                    }));
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                                {status.label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}

                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value) =>
                                  !value ||
                                  !filterData.toDate ||
                                  new Date(value) <=
                                    new Date(filterData.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, filterData) =>
                                  !filterData.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <span className="error-text">
                                      {errors.fromDate.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value) =>
                                  !value ||
                                  !filterData.fromDate ||
                                  new Date(value) >=
                                    new Date(filterData.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, filterData) =>
                                  !filterData.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <span className="error-text">
                                      {errors.toDate.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RoleFilterModal;
